'use client';

import { checkForConsent } from '@wt/shared/hooks/useAds/useAds';
import { useEffect } from 'react';

export default function CheckForConsent() {
  useEffect(() => {
    checkForConsent();
  }, []);

  return <></>;
}
